export const DEFAULT_EEAP_PREAPPROVED_CATEGORIES = [
  'Hard Hat',
  'Safety Glasses',
  'Gloves',
  'Hi-Vis Vest',
  'Coat',
  'Bibs',
  'Rain Gear',
  'Hand Tools',
  'Other (describe)',
]

export const MAX_EEAP_PREAPPROVED_CATEGORIES = 40
export const MAX_EEAP_ITEM_CATEGORY_LENGTH = 80
